import React, { forwardRef, memo } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';

import { Button } from '../../material-ui/Button';
import { useStyles } from './useStyles';

export const Filter = memo(
    forwardRef(({ onFilter, children, onClear, className }, ref) => {
        const classes = useStyles();
        const classNames = classnames(classes.filter, className);
        const { t: translate } = useTranslation();

        return (
            <div className={classNames} ref={ref}>
                {children}
                <Button className={classes.filterButton} variant="contained" color="primary" onClick={onFilter}>
                    {translate('filters.filter')}
                </Button>
                <Button className={classes.filterClearButton} variant="contained" {...(onClear && { onClick: onClear })}>
                    {translate('filters.clear')}
                </Button>
            </div>
        );
    })
);

Filter.displayName = 'Filter';
